import { useContext } from 'react';
import { SignalRContext } from 'context/context';

export const useSignalR = () => useContext(SignalRContext);
